import { useCallback, useEffect, useState } from "react";
import { db } from "../firebase";
import { collection, getDocs } from "firebase/firestore";

/**
 * Biblioteca de materiales comerciales (colección `materiales`, compartida).
 * Cada material es un folleto/flyer editable (por ahora tipo
 * "flyer_desarrolladoras"). Cache a nivel módulo para no releer al navegar.
 */
let _cache = null;

async function fetchAll() {
  const snap = await getDocs(collection(db, "materiales"));
  const materiales = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
  materiales.sort((a, b) => String(a.nombre || "").localeCompare(String(b.nombre || "")));
  return { materiales };
}

export function useMaterialesData() {
  const [state, setState] = useState(() =>
    _cache ? { ..._cache, loading: false, error: null } : { materiales: [], loading: true, error: null }
  );

  const load = useCallback(async (force = false) => {
    if (_cache && !force) { setState({ ..._cache, loading: false, error: null }); return; }
    setState((s) => ({ ...s, loading: true }));
    try {
      _cache = await fetchAll();
      setState({ ..._cache, loading: false, error: null });
    } catch (e) {
      setState((s) => ({ ...s, loading: false, error: e }));
    }
  }, []);

  useEffect(() => { load(false); }, [load]);

  const upsertLocal = useCallback((id, data) => {
    const base = _cache || { materiales: [] };
    const list = base.materiales.slice();
    const idx = list.findIndex((m) => m.id === id);
    if (idx >= 0) list[idx] = { ...list[idx], ...data, id };
    else list.push({ id, ...data });
    list.sort((a, b) => String(a.nombre || "").localeCompare(String(b.nombre || "")));
    _cache = { ...base, materiales: list };
    setState({ ..._cache, loading: false, error: null });
  }, []);

  const removeLocal = useCallback((id) => {
    const base = _cache || { materiales: [] };
    _cache = { ...base, materiales: base.materiales.filter((m) => m.id !== id) };
    setState({ ..._cache, loading: false, error: null });
  }, []);

  return { ...state, reload: () => load(true), upsertLocal, removeLocal };
}
